import { takeEvery } from 'redux-saga'

import actions from 'actions'
import {
  loadCurrentPartnerSettings,
  loadSettings,
  searchPartners,
  searchPortalUsers,
  setUserContext,
} from './settings-sagas'

export function* watchSettingsUpdate() {
  yield* takeEvery(actions.SETTINGS_UPDATE, loadSettings)
}

export function* watchPartnerUpdate() {
  yield* takeEvery(actions.SETTINGS_UPDATE_CURRENT_PARTNER, loadCurrentPartnerSettings)
}

export function* watchPortalUserSearch() {
  yield* takeEvery(actions.SETTINGS_UPDATE_PORTAL_USER_SEARCH_RESULTS, searchPortalUsers)
}

export function* watchPartnerSearch() {
  yield* takeEvery(actions.SETTINGS_UPDATE_PARTNER_SEARCH_RESULTS, searchPartners)
}

export function* watchSettingsSuccess() {
  yield* takeEvery(actions.ENTITIES_SETTINGS.SUCCESS, setUserContext)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/settings/settings-watchers.js
 **/